import { Link } from "react-router-dom";
import { topComments } from "@/mocks/events";
import { formatCount } from "@/utils/format";

export default function LiveComments() {
  const list = topComments.slice(3, 7);

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
      {list.map((item, index) => (
        <figure
          key={item.id}
          className={`flex h-full flex-col rounded-lg border p-5 md:p-6 ${
            index % 2 === 0
              ? "border-secondary-200 bg-secondary-50"
              : "border-accent-200 bg-accent-50"
          }`}
        >
          <i
            className={`ri-double-quotes-l text-3xl ${
              index % 2 === 0 ? "text-secondary-400" : "text-accent-500"
            }`}
          ></i>
          <blockquote className="mt-3 flex-1 text-base leading-relaxed text-foreground-900">
            {item.content}
          </blockquote>
          <figcaption className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-foreground-950/10 pt-4">
            <div className="flex min-w-0 items-center gap-2.5">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-sm font-bold text-background-50">
                {item.nickname.slice(0, 1)}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-foreground-950">{item.nickname}</p>
                <p className="truncate text-xs text-foreground-500">{item.categoryName}</p>
              </div>
            </div>
            <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-primary-600">
              <i className="ri-thumb-up-line text-sm"></i>
              {formatCount(item.likes)}
            </span>
          </figcaption>
          <Link
            to={`/event/${item.eventId}`}
            className="mt-3 inline-flex items-center gap-1 truncate text-xs text-foreground-600 transition-colors hover:text-primary-600"
          >
            <i className="ri-link"></i>
            出自：{item.eventTitle}
          </Link>
        </figure>
      ))}
    </div>
  );
}